/**
 * Created by Andrey Popov on 11/26/25.
 */

const SmallContentDocker = function (scroll, dockOptions) {
    this.scroll = scroll;
    this.dockToEnd = dockOptions.toEnd;

    this.dockDirection = undefined;
};

SmallContentDocker.prototype.isDocked = function () {
    return this.dockDirection !== undefined;
};

SmallContentDocker.prototype.undock = function () {
    if (this.isDocked()) {
        delete this.dockDirection;
        this.scroll.calcBorders();
        this.scroll.scrollTo(this.dockToEnd ? cleverapps.UI.ScrollView.SCROLLS.LOWER_RIGHT : cleverapps.UI.ScrollView.SCROLLS.UPPER_LEFT);
    }
};

SmallContentDocker.prototype.dock = function () {
    let dockDirection = undefined;
    if (this.scroll.direction === cleverapps.UI.ScrollView.DIR_VERTICAL) {
        dockDirection = this.dockToEnd ? cleverapps.UI.DOCK_BOTTOM : cleverapps.UI.DOCK_TOP;
    } if (this.scroll.direction === cleverapps.UI.ScrollView.DIR_HORIZONTAL) {
        dockDirection = this.dockToEnd ? cleverapps.UI.DOCK_RIGHT : cleverapps.UI.DOCK_LEFT;
    }

    let x = 0;
    let y = 0;
    let didDock = false;

    switch (dockDirection) {
        case cleverapps.UI.DOCK_LEFT:
            if (this.scroll.innerContent.width < this.scroll.width) {
                x = (this.scroll.innerContent.width - this.scroll.width) / 2;
                didDock = true;
            }
            break;

        case cleverapps.UI.DOCK_RIGHT:
            if (this.scroll.innerContent.width < this.scroll.width) {
                x = (this.scroll.width - this.scroll.innerContent.width) / 2;
                didDock = true;
            }
            break;

        case cleverapps.UI.DOCK_TOP:
            if (this.scroll.innerContent.height <= this.scroll.height) {
                y = (this.scroll.height - this.scroll.innerContent.height) / 2;
                didDock = true;
            }
            break;

        case cleverapps.UI.DOCK_BOTTOM:
            if (this.scroll.innerContent.height <= this.scroll.height) {
                y = (this.scroll.innerContent.height - this.scroll.height) / 2;
                didDock = true;
            }
            break;
    }

    if (didDock) {
        this.scroll.innerContent.setPosition(x, y);
        this.dockDirection = dockDirection;
        this.scroll.min.x = this.scroll.max.x = -x;
        this.scroll.min.y = this.scroll.max.y = -y;
    } else if (this.isDocked()) {
        this.undock();
    }
};